import moment from 'moment';

export const DEFAULT_BADGE_OVERRIDE_DURATION_DAYS = 7;

export function setAllowPrint(companyAssociation, override = false) {
  if (!companyAssociation) return false;
  let allowPrint;

  // check do not admit (disable print if true)
  allowPrint =
    companyAssociation.company &&
    !companyAssociation.person.doNotAdmit &&
    !companyAssociation.company.doNotAdmit &&
    companyAssociation.isActive &&
    companyAssociation.person.isActive &&
    companyAssociation.company.isActive;

  if (allowPrint && companyAssociation.qualificationStatus != null) {
    allowPrint = companyAssociation.qualificationStatus.isQualified;
  }

  if (override) {
    allowPrint = true;
  }

  return allowPrint;
}

export function getBadgeOverrideDurationMs(settings = {}) {
  const configuredDays = Number(settings.badgeOverrideDurationDays);
  if (Number.isFinite(configuredDays) && configuredDays > 0) {
    return configuredDays * 24 * 60 * 60 * 1000;
  }

  return DEFAULT_BADGE_OVERRIDE_DURATION_DAYS * 24 * 60 * 60 * 1000;
}

export function getBadgeOverrideExpiresAt(overrideCreatedOn, settings = {}) {
  if (!overrideCreatedOn) return null;
  const createdOnMs = Date.parse(overrideCreatedOn);
  if (!Number.isFinite(createdOnMs)) return null;
  return createdOnMs + getBadgeOverrideDurationMs(settings);
}

export function getActiveOverrideUser(
  overrideUser,
  overrideExpiresAt,
  now = Date.now()
) {
  if (!overrideUser || !overrideExpiresAt) return null;
  return now < overrideExpiresAt ? overrideUser : null;
}

export function getActiveOverrideFromLatest(
  latestOverride,
  settings = {},
  now = Date.now()
) {
  if (!latestOverride?.overrideUserId) return null;
  const overrideExpiresAt = getBadgeOverrideExpiresAt(
    latestOverride.createdOn,
    settings
  );
  if (!overrideExpiresAt || now >= overrideExpiresAt) return null;
  return { overrideUser: latestOverride.overrideUserId, overrideExpiresAt };
}

export function willCallAllowPrint(willCall) {
  return willCall.exhibitor.qualificationStatus.isQualified;
}
export function checkValidMarket(market) {
  return moment().isBetween(
    market.registrationStartDate,
    market.registrationEndDate
  );
}

export function attendeeAllowPrint(attendee) {
  const {
    event: { eventDates },
  } = attendee;
  let allowPrint = false;
  // if there are event dates, check if today is between the start and end date
  if (eventDates && eventDates.length > 0) {
    const dates = eventDates.map((event) => new Date(event.date));
    const startDate = new Date(Math.min(...dates));
    const endDate = new Date(Math.max(...dates));
    const today = new Date().setHours(0, 0, 0, 0);
    if (today >= startDate && today <= endDate) {
      allowPrint = true;
    }
  }
  return allowPrint;
}
